<template>
    <div class="w-100 h-100 position-relative host">
        <page-header :ulogo="single.ulogo"></page-header>
        <div class="page-body" style="background-color: #2f878c;">
            <div v-if="!ready"
                 style="height:493px;background-color: #2f878c;display: flex;justify-content: center;align-items: center">
                <div style="font-size: 28px;color:white">
                    <div class="container">
                        {{ error }}
                    </div>
                </div>
            </div>
            <div class="body-wrap" v-if="ready">
                <ul class="login-table">
                    <li>
                        <label>会议名称:</label>
                        <span>#{{ single.id }} {{ single.topic }}</span>
                    </li>
                    <li>
                        <label>会议时间:</label>
                        <span>{{ single.meeting_date }} {{ single.meeting_time }}</span>
                    </li>
                    <li>
                        <label>会议时长:</label>
                        <span>{{ single.duration_hour }}</span>
                    </li>
                    <li><label>主持人:</label>
                        <span>{{ single.host_name }}</span>
                    </li>
                    <li><label>会议号码:</label>
                        <span>{{ single.meeting_id }}</span></li>
                    <li></li>
                    <li>
                        <label>参会链接:</label>
                        <div> 发给与会者:<br/>
                            <div style="width: 100%;overflow-x: auto"> {{ single.join_url }}</div>

                            <vue-qrcode :value="single.join_url" :options="{width:120}" v-if="qrcode"></vue-qrcode>
                        </div>
                    </li>
                    <li><label>会议介绍:</label>
                        <span v-html="single.description" style="height: 80px;"></span></li>
                    <li v-if="single.message">
                        <div class="text-center font-weight-bolder"
                             v-html="single.message"></div>
                    </li>
                    <li v-if="url"><label><b>主持链接:</b></label>
                        <div v-if="single.sso_message" class="mb-2 text-center">
                            {{single.sso_message}}
                        </div>
                        <div v-else style="font-size: 1.2em"><a style="color: coral;text-decoration: underline;" href="javascript:void(0);" @click="jumpToHost">
                                       <i class="el-icon-link"></i> 点击主持会议</a>
                        </div>
                    </li>
                </ul>
            </div>
        </div>
        <div class="page-footer">
            <page-footer></page-footer>
        </div>
        <div class="position-absolute w-100 h-100 text-right"
             style="z-index:1;top:0;left:0;background-color: rgba(0,0,0,0.8)"
             v-if="wechat_notice_visible">
            <img src="../assets/images/wechat-notice.png" style="max-width: 100%">
        </div>
    </div>
</template>

<script>
import {mapState, mapMutations} from "vuex";
import PageHeader from "../components/page-header";
import PageFooter from "../components/page-footer";
import VueQrcode from "@chenfengyuan/vue-qrcode";

export default {
    name: "host",
    components: {PageHeader, PageFooter, VueQrcode},
    data() {
        return {
            single: {},
            ready: false,
            error: '',
            url: null,
            wechat_notice_visible: false
        }
    },
    computed: {
        ...mapState(['user', 'process']),
        qrcode() {
            return !this.$organization.no_qrcode;
        }
    },
    methods: {
        ...mapMutations('user', ['setUserInfo']),
        jumpToHost() {
            if (this.$isWechat()) {
                this.wechat_notice_visible = true;
            } else {
                window.location.href = this.url;
            }
        }

    },
    mounted() {
        if (!this.$route.query._t) {
            //this.$router.replace('/');
        } else {
            this.$api('Query.Host', {_t: this.$route.query._t}).then(res => {
                if (res.data.success) {
                    this.single = res.data.data;
                    this.ready = true;

                    if (this.single.start_url && !this.single.message) {
                        this.url = this.single.start_url;
                        const vm = this;
                        if (!this.$isWechat())
                            setTimeout(function () {
                                    window.location.href = vm.url;
                                },
                                3000);
                    }
                } else {
                    this.error = res.data.text
                }
                console.log(res);
            });
        }
    }
}
</script>

<style scoped lang="less">

.host {
    .page-header {
        height: 120px;
        padding: 10px 0;

        .logo {
            display: flex;

            img {
                max-height: 70px;
            }

            .title {
                padding-top: 10px;
                padding-left: 20px;
                font-size: 30px;
                font-weight: 400;
                color: #607d8b;
            }
        }

    }

    .page-body {
        min-height: 493px;
        background-color: #d9e3e3;
        position: relative;
        text-align: center;


        .login-table {
            padding-top: 20px;
            padding-bottom: 20px;
            display: inline-block;
            text-align: left;

            color: white;
            list-style: none;

            li {
                list-style: none;
                margin: 0;
                padding: 0;
                display: flex;

                label {
                    margin-right: 20px;
                    width: 80px;
                    text-align: right;
                    flex: 0 0 80px;
                }

                & > span {
                    flex: 1 1 400px;
                    font-weight: bold;
                    overflow: auto;
                }

                & > div {
                    flex: 1 1 400px;
                    font-weight: bold;
                    overflow: auto;
                }
            }

            a {
                color: azure;
            }
        }
    }

    .page-footer {
        min-height: 87px;
    }

    .page-container {
        position: relative;
        width: 100%;
        max-width: 990px;
        margin: 0 auto;

        .contact {
            position: relative;
            text-align: center;
            padding: 15px 0 20px 4px;
            line-height: 26px;
            font-size: 14px;

        }
    }
}


</style>
